import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getSales = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  if (req.shipping_status) queryParams.set("shipping_status", req.shipping_status);
  if (req.order_type) queryParams.set("order_type", req.order_type);
  return await customFetch(
    `v1/sales?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getSaleDetail = async (id: string) => {
  return await customFetch(`v1/sales/${id}`, {
    method: "GET",
  });
};
export const getSaleDownload = async (id: string) => {
  return await customFetch(`v1/sales/${id}/download`, {
    method: "GET",
  });
};
export const createSales = async (data: any) => {
  return await customFetch("v1/sales", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateSales = async (id: string, data: any) => {
  return await customFetch(`v1/sales/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteSales = async (id: string) => {
  return await customFetch(`v1/sales/${id}`, {
    method: "DELETE",
  });
};


export const getTopSaless = async () => {
  return await customFetch("v1/sales/top", {
    method: "GET",
  });
};

export const addTopSales = async (data: any) => {
  return await customFetch("v1/sales/top", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateTopSales = async (salesId: string, data: any) => {
  return await customFetch(`v1/sales/top/${salesId}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteTopSales = async (salesId: string) => {
  return await customFetch(`v1/sales/top/${salesId}`, {
    method: "DELETE",
  });
};


export const countPendingSales = async () => {
    return await customFetch(`v1/sales/count-pending`, {
      method: "GET",
    });
  };
  
  